import { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { IconButton, IconButtonProps } from "@mui/material";

const useStyles = makeStyles()({
    icon: {
        fontSize: 16,
    },
});

type ExpandToggleButtonProps = Omit<IconButtonProps, "children" | "aria-label" | "aria-expanded"> & {
    expanded: boolean;
    // Optional: a few call sites let an enclosing row or header own the click.
    onClick?: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    size?: "small" | "large";
    className?: string;
    iconClassName?: string;
    tabIndex?: number;
    expandLabel?: string;
    collapseLabel?: string;
};

export const ExpandToggleButton = ({
    expanded,
    onClick,
    disabled,
    size = "large",
    className,
    iconClassName,
    tabIndex,
    expandLabel,
    collapseLabel,
    ...rest
}: ExpandToggleButtonProps) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation(["common"]);

    const label = expanded ? (collapseLabel ?? t("common:aria.collapse")) : (expandLabel ?? t("common:aria.expand"));

    return (
        <IconButton
            {...rest}
            size={size}
            className={className}
            disabled={disabled}
            onClick={onClick}
            tabIndex={tabIndex}
            aria-expanded={expanded}
            aria-label={label}
        >
            <i
                aria-hidden="true"
                className={cx("fa-solid", expanded ? "fa-chevron-down" : "fa-chevron-right", iconClassName ?? classes.icon)}
            />
        </IconButton>
    );
};
